import { STATUS_COURSE, STATUS_TEXT, TARJETA_COLOR } from "#training/constants"
import CircleIcon from "@mui/icons-material/Circle"
import { Box, Stack } from "@mui/material"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"

export default function TrainingColor() {
	let xsList = {
		flex: "1",
		textAlign: "center",
		alignItems: "center", // Alinea los elementos en el centro verticalmente
		justifyContent: "center", // Alinea los elementos en el centro horizontalmente
	}
	let xsIcon = {
		marginBottom: 0,
	}

	const values = Object.values(STATUS_COURSE)
	values.pop()

	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: "center",
				height: "100%",
			}}
		>
			<List
				sx={{
					display: "flex",
					flexDirection: "row",
					width: "70vw",
					height: "70%",
					background: "#0FFFFF00",
					overflowX: "auto",
				}}
			>
				{values.map((value, index) => {
					return (
						<ListItem
							key={value}
							disableGutters
							sx={{
								...xsList,
								borderRight: values.length - index > 1 ? "1px solid #ccc" : "none",
							}}
						>
							<Stack direction={"column"} spacing={1} alignItems="center">
								<CircleIcon
									sx={{
										...xsIcon,
										color: TARJETA_COLOR[value],
										stroke: "#000000", // contorno negro
										strokeWidth: value === 0 ? 2 : 0,
									}}
								/>
								<ListItemText primary={`${STATUS_TEXT[value]}`} />
							</Stack>
						</ListItem>
					)
				})}
			</List>
		</Box>
	)
}
